import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import axios from 'axios'
import {services, getHeader, getKycHeader} from '@/assets/js/config.js'
import swal from 'sweetalert2';
import debounce from 'lodash.debounce';

export {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader,
  getKycHeader,
  swal,
  debounce
}